import React from "react";
import { ReactSVG } from "react-svg";
import { Empty } from "antd";
import { getPanesIcon } from "../../../../utils/images";
import "./LocationPane.scss";
import "leaflet/dist/leaflet.css";
import LocationTrackMap from "../../../LocationTrack/LocationTrackMap/LocationTrackMap";
import LocationTrackTransit from "../../../LocationTrack/LocationTrackTransit/LocationTrackTransit";


const LocationPaneWrapper = ({ shipment }) => {
  return (
    <div className="LocationPaneWrapper">
      {(shipment.lat && shipment.lng) ? <LocationTrackMap shipment={shipment} /> : <></>}
      {(shipment.transits.length || shipment.pod.name) ? <LocationTrackTransit shipment={shipment} /> : <></>}
      {!(shipment.lat || shipment.lng || shipment.transits.length || shipment.pod.name) ? <Empty /> : <></>}
    </div>
  )
}

const LocationPane = ({ shipment }) => {
  return (
    <div className="LocationPane pane">
      <div className="pane__header">
        <ReactSVG src={getPanesIcon('location')} />
        <div className="pane__title">Track Location</div>
      </div>
      <div className="pane__wrapper">
        <LocationPaneWrapper shipment={shipment} />
      </div>
    </div>
  )
}

export default LocationPane;
